module.exports = __webpack_public_path__ + "img/Recurso 35@300x.208d9757.webp";